import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // Add this import
import quantumLogo from "../../quantum-care-logo.png";
import "../../App.css";
import Login from "../Login/Login";
import { User, Stethoscope, HeartPulse } from "lucide-react";
function Header() {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isDoctorLoginOpen, setIsDoctorLoginOpen] = useState(false);
  const [isNurseLoginOpen, setIsNurseLoginOpen] = useState(false);
  const [loginFor, setLoginFor] = useState("patient"); // Default value
  const location = useLocation(); // Get current location

  // Effect to determine loginFor based on current URL
  useEffect(() => {
    const currentPath = location.pathname.toLowerCase();

    if (currentPath.includes("doctor")) {
      setLoginFor("doctor");
    } else if (currentPath.includes("nurse")) {
      setLoginFor("nurse");
    } else if (currentPath.includes("patient")) {
      setLoginFor("patient");
    } else {
      // Default to patient if none found
      setLoginFor("patient");
    }
  }, [location.pathname]); // Re-run when pathname changes

  return (
    <>
      <header className="fixed top-0 left-0 w-full z-50 px-8 py-3 bg-white shadow-sm">
        <div className="max-w-7xl w-full mx-auto flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <img
              src={quantumLogo}
              alt="Quantum Care Solutions"
              className="h-14"
            />
          </div>

          {/* Navigation */}
          <nav className="flex items-center space-x-4">
            <a href="tel:911" className="text-red-500 font-bold">
              Emergency Call 911
            </a>
            {/* <a
              href="#how-it-works"
              className="text-gray-700 hover:text-green-600 font-medium"
            >
              How it works
            </a>
            <a
              href="#features"
              className="text-gray-700 hover:text-green-600 font-medium"
            >
              Features
            </a> */}
            <button
              className="flex items-center gap-2 rounded-full bg-green-400 px-4 py-2 text-white font-medium shadow hover:bg-green-600 transition"
              onClick={() => setIsLoginOpen(true)}
            >
              <User className="w-4 h-4" />
              Patient Login
            </button>

            <button
              className="flex items-center gap-2 rounded-full bg-purple-500 px-4 py-2 text-white font-medium shadow hover:bg-purple-600 transition"
              onClick={() => setIsNurseLoginOpen(true)}
            >
              <HeartPulse className="w-4 h-4" />
              Nurse Login
            </button>
            <button
              className="flex items-center gap-2 rounded-full bg-blue-500 px-4 py-2 text-white font-medium shadow hover:bg-blue-600 transition"
              onClick={() => setIsDoctorLoginOpen(true)}
            >
              <Stethoscope className="w-4 h-4" />
              Doctor Login
            </button>
            {/* <button
              onClick={() => setIsLoginOpen(true)}
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-5 py-2 rounded-lg"
            >
              Login / Register
            </button> */}
          </nav>
        </div>
      </header>
      <div className="pt-16">
        <Login
          isOpen={isLoginOpen}
          onClose={() => setIsLoginOpen(false)}
          loginFor="patient" // Dynamic value based on URL
        />
        <Login
          isOpen={isDoctorLoginOpen}
          onClose={() => setIsDoctorLoginOpen(false)}
          loginFor="doctor" // Dynamic value based on URL
        />
        <Login
          isOpen={isNurseLoginOpen}
          onClose={() => setIsNurseLoginOpen(false)}
          loginFor="nurse" // Dynamic value based on URL
        />
      </div>
    </>
  );
}

export default Header;
